<template>
  <span class="calendar-event-action-button-component">
    <a class="btn btn-circle btn-lg btn-info tooltip-toggle add-appointment" data-toggle="tooltip"
       data-placement="bottom" title="Nieuwe afspraak" style="margin-right: 10px;" @click="showModal = true"><i
        class="mdi mdi-calendar"></i></a>
    <modal-create-or-edit-component :is-new-event="showModal"
                                    :customer-id="customerId"
                                    :attachable-key="instanceId"
                                    :attachable-type="instanceType"
                                    :attachable-description="instanceDescription"
                                    @close="showModal = false"></modal-create-or-edit-component>
  </span>
</template>

<script>
import ModalCreateOrEditComponent from "./ModalCreateOrEditComponent.vue";

export default {
  name: "CalendarEventActionButtonComponent",
  components: {ModalCreateOrEditComponent},
  data() {
    return {
      showModal: false,
    }
  },
  props: {
    customerId: {
      type: [String, Number],
      required: false,
    },
    instanceType: {
      type: String,
      required: false,
    },
    instanceId: {
      type: [String, Number],
      required: false,
    },
    instanceDescription: {
      type: String,
      required: false,
    }
  },
}
</script>